import axiosInstance from "../configs/axios";
import {route} from "ziggy-js";

/**
 * Sends a login request to the server.
 *
 * @param {FormData} formData - The form data containing login information.
 * @returns {Promise<Object>} - A promise that resolves with the server's response data.
 * @throws {Error} - Throws an error if the request fails with a server error (500+).
 */
export async function login(formData) {
    return (await axiosInstance.post(route('jsapi.login.send'), formData)).data;
}

/**
 * Sends a registration request to the server.
 *
 * @param {FormData} formData - The form data containing registration information.
 * @returns {Promise<Object>} - A promise that resolves with the server's response data.
 * @throws {Error} - Throws an error if the request fails with a server error (500+).
 */
export async function register(formData) {
    return (await axiosInstance.post(route('jsapi.register.send'), formData)).data;
}

/**
 * Sends a password reset request to the server.
 *
 * @param {FormData} formData - The form data containing the email for password reset.
 * @returns {Promise<Object>} - A promise that resolves with the server's response data.
 * @throws {Error} - Throws an error if the request fails with a server error (500+).
 */
export async function resetPassword(formData) {
    return (await axiosInstance.post(route('jsapi.resetPassword.send'), formData)).data;
}

/**
 * Sends a request to confirm registration using a numeric token.
 *
 * @param {FormData} formData - The form data containing the email and confirmation token.
 * @returns {Promise<Object>} - A promise that resolves with the server's response data.
 * @throws {Error} - Throws an error if the request fails with a server error (500+).
 */
export async function confirmRegister(formData) {
    return (await axiosInstance.post(route('jsapi.register.confirmEmailWithNumericToken'), formData)).data;
}

/**
 * Sends a request to resend the verification email.
 *
 * @param {FormData} formData - The form data containing the email for re-verification.
 * @returns {Promise<Object>} - A promise that resolves with the server's response data.
 * @throws {Error} - Throws an error if the request fails with a server error (500+).
 */
export async function resendVerification(formData) {
    return (await axiosInstance.post(route('jsapi.register.resendEmailVerification'), formData)).data;
}

/**
 * Sends a request to change the user's password.
 *
 * @param {FormData} formData - The form data containing the current password, new password, and confirmation.
 * @returns {Promise<Object>} - A promise that resolves with the server's response data.
 * @throws {Error} - Throws an error if the request fails with a server error (500+).
 */
export async function resetPasswordChange(formData) {
    return (await axiosInstance.post(route('jsapi.passwordReset.send'), formData)).data;
}

/**
 * Sends a request to change the user's password.
 *
 * @param {FormData} formData - The form data containing the current password, new password, and confirmation.
 * @returns {Promise<Object>} - A promise that resolves with the server's response data.
 * @throws {Error} - Throws an error if the request fails with a server error (500+).
 */
export async function changePassword(formData) {
    return (await axiosInstance.post(route('jsapi.passwordChange.send'), formData)).data;
}
